import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgShieldCheck = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path d="M11.985 21.606s7.672-2.323 7.672-8.727c0-6.405.277-6.905-.338-7.521-.616-.616-6.328-2.608-7.334-2.608S5.265 4.742 4.65 5.358c-.617.616-.338 1.116-.338 7.521s7.672 8.727 7.672 8.727" />
      <path d="m9.386 11.875 1.892 1.895 3.898-3.9" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgShieldCheck);
export default ForwardRef;
